'use client';

import React, { useState, useEffect } from 'react';

interface ClientOnlyTimeProps {
  date: Date;
  format?: 'time' | 'datetime' | 'date';
  className?: string;
}

export const ClientOnlyTime: React.FC<ClientOnlyTimeProps> = ({
  date,
  format = 'time',
  className
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    // Return a placeholder during SSR to prevent hydration mismatch
    return <span className={className}>--:--:--</span>;
  }

  const formatTime = () => {
    switch (format) {
      case 'datetime':
        return date.toLocaleString();
      case 'date':
        return date.toLocaleDateString();
      case 'time':
      default:
        return date.toLocaleTimeString();
    }
  };

  return <span className={className}>{formatTime()}</span>;
};
